import { merge } from "lodash.merge";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { createWithEqualityFn } from "zustand/traditional";

import {
  ingestAdvisorSponsorData,
  ingestData,
  ingestSponsorData,
  ingestTerritoryData,
} from "../utils/helpers/intakeForm";

export const initialFormState = {
  status: "draft",
  isFormDirty: false,
  isFormLocked: false,
  category: null,
  strategyCode: null,
  strategyName: null,
  strategyDetail: {},
  minCredQual: null,
  taxLotData: {
    csvFileName: null,
    csvLength: 0,
    csvErrorRowsLength: 0,
    totalErrorCount: 0,
  },
  accountRestrictionData: {
    csvFileName: null,
    csvLength: 0,
    csvErrorRowsLength: 0,
    totalErrorCount: 0,
  },
  clientDetails: {},
};

const useStore = createWithEqualityFn(
  devtools(
    persist(
      (set, get) => ({
        data: {
          formData: null,
          formState: initialFormState,
          formOptions: {
            esg: [],
            taxState: [],
            fundingSource: [],
            statePreference: [],
            yearsToTransition: [],
            categories: [],
            strategies: {},
            strategyDetails: [],
            sessionProposals: [],
            state: [],
            sector: [],
            territories: [],
            advisorSponsorList: [],
          },
        },
        actions: {
          // =======================
          // STATE ACTIONS SETTERS
          // =======================
          handleSetIntakeFormValue: (data) => {
            set((s) => ({
              data: {
                ...s.data,
                formData: data ? { ...s.data.formData, ...data } : null,
              },
            }));
          },
          handleSetIntakeFormStates: (data) => {
            set((s) => ({
              data: {
                ...s.data,
                formState: { ...s.data.formState, ...data },
              },
            }));
          },
          handleSetIntakeFormOptions: (data) => {
            set((s) => ({
              data: {
                ...s.data,
                formOptions: { ...s.data.formOptions, ...data },
              },
            }));
          },
          handleSetIntakeFormOptionsGeneric: (data) => {
            set((s) => ({
              data: {
                ...s.data,
                formOptions: {
                  ...s.data.formOptions,
                  esg: ingestData(data, "ESG"),
                  taxState: ingestData(data, "TaxState"),
                  fundingSource: ingestData(data, "FundingSource"),
                  statePreference: ingestData(data, "StatePreference"),
                  yearsToTransition: ingestData(data, "YearsToTransition"),
                  territories: ingestTerritoryData(data["Territories"].sort()),
                  advisorSponsorList: ingestAdvisorSponsorData(data["Sponsor"]),
                },
              },
            }));
          },
          handleSetIntakeFormOptionsSponsor: (data) => {
            set((s) => ({
              data: {
                ...s.data,
                formOptions: {
                  ...s.data.formOptions,
                  ...ingestSponsorData(data),
                  strategyDetails: data,
                },
              },
            }));
          },
          handleSetIntakeFormSessionProposals: (data) => {
            set((s) => ({
              data: {
                ...s.data,
                formOptions: {
                  ...s.data.formOptions,
                  sessionProposals: data,
                },
              },
            }));
          },
          handleSetIntakeFormExclusionDataWithField: (data, field) => {
            set((state) => ({
              data: {
                ...state.data,
                formOptions: {
                  ...state.data.formOptions,
                  [field]: data,
                },
              },
            }));
          },
        },
      }),
      {
        name: "api-intake-form-options",
        storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used,
        partialize: (state) => ({
          data: { formOptions: state.data.formOptions },
        }),
        merge: (persistedState, currentState) =>
          merge(persistedState, currentState),
      }
    )
  )
);

export default useStore;
